import Api from "../Utils/Axios";

export const ImagesUpload = async (data) => {
  const response = await Api.post("general/uploadFiles/?returnUrls=true", data);
  return response.data;
};
